
import { HTTPClient } from "./Client";

const DocumentoApi = {

    async CarregarDocumento(formData) {
        try {
            const response = await HTTPClient.post(`/Documento/CarregarDocumento`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            });
            return response.data;
        } catch (error) {
            console.error("Erro ao Salvar documento:", error);
            throw error;
        }
    },

    async ObterDocumento(pessoaId) {

        const response = await HTTPClient.get(`/Documento/ObterDocumentoPorPessoa/${pessoaId}`);

        return response.data;
    },

    async ObterDocumentoPorPaginacao(pessoaId, pagina, titulo, statusDocumentoEnum) {
        var pagina = {
            Pagina: pagina,
            Titulo: titulo,
            StatusDocumentoEnum: Number(statusDocumentoEnum)
        }

        const response = await HTTPClient.post(`/Documento/ListarDocumentoPaginacaoPorPessoaId/${pessoaId}`, pagina);
        return response.data;
    },

    async RemoverDocumento(documentoId) {

        const response = await HTTPClient.put(`/Documento/RemoverDocumento/${documentoId}`);
        return response.data;
    },

    async ListarTipoEnum() {
        const response = await HTTPClient.get(`/Documento/ListarStatusDocumentoTipos`);

        return response.data;
    },
    async ListarStatusEnum() {
        const response = await HTTPClient.get(`/Documento/ListarStatusdocumentos`);
        return response.data;
    },
    async AtualizarStatus(documentoId, statusDocumentoEnum) {

        var stats = {
            StatusDocumentoEnum: statusDocumentoEnum
        }

        const response = await HTTPClient.put(`/Documento/AtualizarStatus/${documentoId}`, stats);
        return response.data;
    },

    async BaixarDocumento(documentoId) {
        const response = await HTTPClient.get(`/Documento/BaixarDocumento/${documentoId}`, {
            responseType: 'blob',
        });
        return response;
    }

}

export default DocumentoApi;